import React, { useState } from 'react'
import parentsteptwoStyle from './ParentRegisterMobilStepTwo.module.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function ParentRegisterMobilStepTwo() {

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  return (
    <>
      <div className={parentsteptwoStyle.parentstepperTwo}>
        <div className='row'>
          <div className='col-7'>
            <h3> Choose a Password </h3>
          </div>
          <div className='col-5'> </div>
        </div>
        <h5> Password Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={parentsteptwoStyle.parentpasswordWrapper}>
                <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${parentsteptwoStyle.parenttwoInputs} form-control`} placeholder='Choose your password' name="password" required />
                <div className={parentsteptwoStyle.parentsteptwotogglebutton} onClick={togglePasswordVisibility}>
                  {isPasswordVisible ? <FaEyeSlash className={parentsteptwoStyle.eyesiconColor} /> : <FaEye className={parentsteptwoStyle.eyesiconColor} />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={parentsteptwoStyle.parentpasswordWrapper}>
                <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${parentsteptwoStyle.parenttwoInputs} form-control`} placeholder='Confirm your password' name="confirmPassword" required />
                <div className={parentsteptwoStyle.parentsteptwotogglebutton} onClick={toggleCPasswordVisibility}>
                  {isCPasswordVisible ? <FaEyeSlash className={parentsteptwoStyle.eyesiconColor} /> : <FaEye className={parentsteptwoStyle.eyesiconColor} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
